<template>
  <div>
    <!-- ProductListDialog 需要判断 确定按钮是否隐藏 -->
    <ProductListDialog
      :dialog-title="dialogTitle"
      :center-dialog-visible="visible"
      :popup-width="'1000px'"
      :modal-append-to-body="true"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
    >
      <!-- <el-form ref="query" :inline="true" :model="query">
      <el-form-item label="商品编号:" prop="skuCode">
        <el-input v-model="query.skuCode" placeholder="商品编号"></el-input>
      </el-form-item>
      <el-form-item label="商品名称:" prop="skuName">
        <el-input v-model="query.skuName" placeholder="商品名称"></el-input>
      </el-form-item>

      <eui-btn type="secondary" @click="handleClear">重11置</eui-btn>
      <eui-btn type="weak" @click="handleSearch">查询</eui-btn>
    </el-form> -->
      <ESearch
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        class="margin-b20"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
        @handleFocus="focusClassify"
      ></ESearch>
      <TableList
        v-if="tableData.length !== 0"
        :table-data="tableData"
        :table-label="tableLabel"
        :loading="loading"
        :selection-show="multipleSelection"
        :row-key="rowKey"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #pic="slot">
          <div style="display: flex; justify-content: center">
            <img :src="slot.scope.row.defaultImage" style="width: 80px; height: 80px; border: 1px solid #d9d9d9" />
          </div>
        </template>
        <template #skuName="slot">
          <div class="table-product-name">
            {{ slot.scope.row.skuName }}
          </div>
        </template>
      </TableList>
      <div v-else>
        <p>提示：若没有可选择的商品数据，需要检查两项内容</p>
        <p>1、商品维护中是否已上传了商品数据</p>
        <p>2、采购商创建的采购协议选择的物料类别需要和您可提供的商品物料类别一致。</p>
      </div>

      <div v-if="tableData.length !== 0" class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </ProductListDialog>
    <!-- 所属分类 -->
    <ClassifyTree
      v-if="classifyVisible"
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyVisible = false"
    ></ClassifyTree>
  </div>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import ProductListDialog from '@/modules/projectA/components/common/e-dialog.vue';
import TableList from '../../common/e-table-list';
import agreementApi from '../../../api/agreement/index';
import ClassifyTree from './classifyTree.vue';

export default {
  name: 'ProductAddDialog',
  components: {
    ProductListDialog,
    TableList,
    ESearch,
    ClassifyTree,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    agreementDetail: {
      type: Object,
      required: true,
    },
    agreementOrigin: {
      type: Boolean,
      required: true,
    },
    materialCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableLabel: !this.agreementDetail.agreementOrgin
        ? [
            {
              label: '图片',
              param: 'defaultImage',
              align: 'center',
              slot: 'pic',
              width: '100',
            },
            {
              label: '商品名称',
              param: 'skuName',
              align: 'center',
              slot: 'skuName',
            },
            { label: '商品编号', param: 'skuCode', align: 'center' },
            { label: '类目名称', param: 'categoryName', align: 'center' },
            {
              label: '计量单位',
              param: 'unitValue',
              align: 'center',
              width: '80',
            },
            // { label: '协议价(元)', param: 'agreementPrice', align: 'center'},
            {
              label: '市场价(元)',
              param: 'price',
              align: 'center',
              width: '100',
            },
            // { label: '优惠比例', param: 'rate', align: 'center',slot:'rate'},
            // { label: '确认状态', param: 'confirmStatus', align: 'center',slot:'confirmStatus'},
          ]
        : [
            {
              label: '图片',
              param: 'defaultImage',
              align: 'center',
              slot: 'pic',
              width: '100',
            },
            {
              label: '商品名称',
              param: 'skuName',
              align: 'center',
              slot: 'skuName',
            },
            { label: '单品编号', param: 'skuCode', align: 'center' },
            { label: '类目名称', param: 'categoryName', align: 'center' },
            { label: '品牌', param: 'brandName', align: 'center' },
            { label: '所属分类', param: 'categoryName', align: 'center' },
            {
              label: '计量单位',
              param: 'unitValue',
              align: 'center',
              width: '80',
            },
            // { label: '协议价(元)', param: 'agreementPrice', align: 'center'},
            {
              label: '市场价(元)',
              param: 'price',
              align: 'center',
              width: '100',
            },
            // { label: '优惠比例', param: 'rate', align: 'center',slot:'rate'},
            // { label: '确认状态', param: 'confirmStatus', align: 'center',slot:'confirmStatus'},
          ], // 正常创建的协议列表数据和从SCM推送过来的数据不一样，有数据后记得改动 todo this.agreementDetail.agreementOrgin记得修改
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      query: {
        skuCode: '',
        skuName: '',
        categoryName: '',
      },
      dialogTitle: '商品清单',
      multipleSelection: true,
      rowKey: 'skuId',
      selectedProduct: [],
      categoryIds: [], // 添加商品搜索时的查询条件

      classifyVisible: false,
      defaultCheckedKeys: [],
      categoryTreeData: [],
      filterInfo: {
        data: {
          skuCode: null,
          skuName: null,
          categoryName: null,
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode', width: '180' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '类目名称',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getMdmTypeListNoPage();
    // this.getProductPriceList();
  },
  methods: {
    // 获取分类树数据
    async getAllCategoryTree() {
      const res = await agreementApi.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.agreementDetail.agreementId,
      });
      if (res.code === '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.query.categoryIds?.length) {
        this.defaultCheckedKeys = this.query.categoryIds;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      if (val?.length === 0) {
        this.query.categoryIds = this.categoryIds;
        this.classifyVisible = false;
        return;
      }
      const filterNode = [];
      val.forEach((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.query.categoryIds = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.filterInfo.data.categoryName = arr.join('、');
      this.classifyVisible = false;
      console.log(this.query.categoryIds, this.filterInfo.data.categoryName);
    },
    handleSearch(val) {
      console.log(val, 'val');
      this.query = { ...this.query, ...val };
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      this.getProductPriceList();
    },
    handleClear() {
      this.filterInfo.data.categoryName = '';
      this.query.skuName = '';
      this.query.skuCode = '';
      this.query.categoryIds = this.categoryIds;
      this.getProductPriceList();
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getProductPriceList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getProductPriceList();
    },
    updateVisible() {
      this.$emit('close');
      this.selectedProduct = [];
    },
    resetPopupData() {
      this.$emit('close');
      this.selectedProduct = [];
    },
    submitPopupData() {
      const params = this.formatAddProductParams();
      if (this.selectedProduct.length > 0) {
        agreementApi.addAgreementPrice(params).then((res) => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '新增协议价商品成功',
            });
            this.$emit('close');
            this.$emit('refreshProduct');
            this.selectedProduct = [];
          }
        });
      } else {
        this.$message({
          type: 'info',
          message: '请选择协议价商品',
        });
      }
    },
    handleSelectionChange(val) {
      this.selectedProduct = val;
    },
    getProductPriceList() {
      const params = this.formatParams();
      agreementApi.getAddProductList(params).then((res) => {
        if (res.data) {
          this.tableData = res.data.records;
          const isEmpty = res.data.records.length !== 0;
          this.$emit('getIsEmpty', isEmpty);
          this.productTagPage.pageTotal = res.data.total;
        }
      });
    },
    formatParams() {
      const res = {};
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.supplierCompanyId = this.agreementDetail.supplierCompanyId;
      res.categoryIds = this.query.categoryIds;
      res.exportStatus = 101;
      res.enable = 1;
      res.skuCode = this.query.skuCode;
      res.skuName = this.query.skuName;
      return res;
    },
    formatConfirmStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '未提交';
          break;
        case 1:
          res = '待确认';
          break;
        case 2:
          res = '已确认';
          break;
        case 3:
          res = '拒绝';
          break;
        default:
          break;
      }
      return res;
    },
    formatRate(row) {
      return row.agreementPrice ? `${(((row.price - row.agreementPrice) / row.price) * 100).toFixed(2)}%` : 0;
    },
    formatAddProductParams() {
      const res = {};
      res.agreementId = this.agreementDetail.agreementId;
      res.agreementCode = this.agreementDetail.agreementCode;
      res.supplierCompanyId = this.agreementDetail.supplierCompanyId;
      res.supplierCompanyName = this.agreementDetail.supplierCompanyName;
      res.materialCode = this.agreementOrigin ? this.materialCode : ''; // 2022-5-18如果是SL,SC则传materialCode
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.agreementPrices = [];

      this.selectedProduct.forEach((item) => {
        const tem = {};
        tem.agreementId = res.agreementId;
        tem.agreementPrice = '';
        // tem.agreementPrice = item.price
        tem.confirmStatus = 0;
        tem.operateSign = 0;
        tem.productCode = item.skuCode;
        tem.productName = item.skuName;
        tem.skuId = item.skuId;

        res.agreementPrices.push(tem);
      });

      return res;
    },
    async getMdmTypeListNoPage() {
      const params = {
        agreementId: this.agreementDetail.agreementId,
      };

      const res = await agreementApi.getMdmTypeList(params);
      if (res.data) {
        for (let i = 0; i < res.data.length; i++) {
          this.categoryIds.push(res.data[i].categoryId);
        }

        this.query.categoryIds = this.categoryIds;

        this.getProductPriceList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
